module.exports = {
      id: "key-validation-usage",
      viewBox: "0 0 86 86",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#key-validation",
      toString: function () {
        return this.url;
      }
    }